export default {
  updateVisitedRoutes: '/auth/updateVisitedRoutes',
  getUserAuthenticationByUid: '/auth/getUserAuthenticationByUid',
  resetPassword: '/auth/resetPassword'
}
